module.exports = __webpack_public_path__ + "img/csvFile.731e6897.svg";